import React, { useMemo } from 'react';
import { CellProps, Column } from 'react-table';
import styles from './ArtistsAdminTable.module.css';
import PaginationTable, {
    PaginationTableProps,
} from '../../../../../ui/DataDisplay/Tables/PaginationTable/PaginationTable';
import Skeleton from '../../../../../ui/Skeleton/Skeleton';
import Image from '../../../../../ui/Image/Image';
import { Artist } from '@round/api';

export type ArtistsAdminTableProps = Omit<PaginationTableProps<Artist>, 'columns'>;

const ArtistsAdminTable = (props: ArtistsAdminTableProps) => {
    const columns: Column<Artist>[] = useMemo(
        () => [
            {
                Header: 'Name',
                id: 'name',
                Cell: ({ row: { original } }: CellProps<Artist>) => {
                    if (props.loading) {
                        return <Skeleton />;
                    }

                    return (
                        <div className={styles.nameContainer}>
                            <Image
                                className={styles.image}
                                src={original.image ?? ''}
                                loading={props.loading}
                                alt={original.name}
                            />
                            <span>{original.name}</span>
                        </div>
                    );
                },
            },
            {
                Header: 'Genres',
                id: 'genres',
                Cell: ({
                    row: {
                        original: { genres },
                    },
                }) => {
                    if (props.loading) {
                        return <Skeleton />;
                    }

                    return <>{genres?.join(', ')}</>;
                },
            },
        ],
        [props.loading]
    );

    return <PaginationTable columns={columns} {...props} />;
};

export default ArtistsAdminTable;
